<template>
    <div class="min-h-screen d-flex flex-column justify-center align-center py-6 py-sm-0 bg-background" :class="bgClass">
        <div>
            <slot name="logo" />
        </div>

        <div class="w-100 px-4 pt-sm-6" style="max-width:550px;">
            <v-card rounded="lg" :variant="cardVariant" :color="cardColor" :class="cardClass">
                <v-card-text class="pb-0 pb-sm-6 pt-6 px-2 px-sm-8">
                    <div class="text-h5  text-center font-weight-medium pb-4">{{ props.title }}</div>
                    <slot />
                </v-card-text>
            </v-card>
            <div class="text-center fw-light pt-4" :class="brandNameClass">&copy; {{ auth.brandName }}</div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { useDisplay } from 'vuetify';
    import appConfig from './../Config/default';
    import { useAuth } from '@/Composables/Auth';
    import { computed } from 'vue';

    const props = defineProps({
        title: {
            type: String,
            default: 'Sign In'
        },
    })

    const auth = useAuth();
    const display = useDisplay();
    const cardVariant = computed(() => {
        return display.smAndUp.value ? `elevated` : `flat`
    });
    const cardColor = computed(() => {
        return display.smAndUp.value ? `surface` : `transparent`
    });
    const cardClass = computed(() => {
        return display.smAndUp.value ? `` : `no-shadow`
    });
    
    const bgClass = computed(() => {
        return display.smAndUp.value ? `bg-background` : `bg-surface`
    });
    const brandNameClass = computed(() => {
        return display.smAndUp.value ? `fs-4` : `fs-3`
    });

</script>